// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ponyta_galar: PokeData = {
  "id": 10162,
  "name": "ponyta-galar",
  "height": 8,
  "weight": 240,
  "base_experience": 82,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "stomp",
    "tackle",
    "take-down",
    "tail-whip",
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "agility",
    "healing-wish",
    "heal-pulse",
    "fairy-wind",
    "dazzling-gleam"
  ],
  "moves": [
    "tackle",
    "growl",
    "psychic",
    "healing-wish",
    "dazzling-gleam",
    "reflect",
    "psywave",
    "future-sight",
    "psychic-fangs",
    "prismatic-cage",
    "psychic-terrain",
    "calm-mind",
    "kinesis"
  ],
  "evolution_chain": {
    "id": 32,
    "item": null,
    "species": [
      {
        "name": "ponyta",
        "order": 83,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rapidash",
        "order": 84,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 77,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 157,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
